import { useQuery } from "@tanstack/react-query";

import { getPdfCropBox } from "@synthesis/shared-services";

export const pdfCropBoxQueryKey = (fileId: string, page: number) => ["pdfCropBox", fileId, page] as const;

export const usePdfCropBox = (fileId: string | undefined, page: number, enabled = true) =>
  useQuery({
    queryKey: pdfCropBoxQueryKey(fileId ?? "", page),
    queryFn: ({ signal }) => getPdfCropBox(fileId!, { page }, { signal }),
    enabled: enabled && !!fileId && page > 0,
    staleTime: Infinity,
    gcTime: 10 * 60 * 1000,
  });
